import { render, staticRenderFns } from "./step_01.vue?vue&type=template&id=51d5bbf0&scoped=true"
import script from "./step_01.vue?vue&type=script&lang=js"
export * from "./step_01.vue?vue&type=script&lang=js"
import style0 from "./step_01.vue?vue&type=style&index=0&id=51d5bbf0&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51d5bbf0",
  null
  
)

export default component.exports